import AppNavigator from "./navigation/AppNavigator";

function App() {
  return <AppNavigator />;
}

export default App;
